import './style.scss';

import Swiper from 'swiper/bundle';

import 'swiper/css/bundle';

const roopSliderInit = () => {
  const roopSlider = new Swiper('.top .roop-slider', {
    loop: true,
    allowTouchMove: false,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    speed: 4000,
    slidesPerView: "auto",
  });
}

const underRoopSliderInit = () => {
  const underRoopSlider = new Swiper('.kameari .roop-slider', {
    loop: true,
    allowTouchMove: false,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    speed: 4000,
    slidesPerView: "auto",
  });
}


window.addEventListener('load', function () {
  roopSliderInit();
  underRoopSliderInit();
});
